export function ColorCircle({ color }: { color: string | null | undefined }) {
  return (
    <span className="colorCircle" style={{ background: color || "" }}></span>
  );
}
